import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import type { BlackbaudRaisersEdgeIntegration } from '@feathr/blackbox';
import { IntegrationSummaryCard } from '@feathr/components';

import { useDisconnect } from './RaisersEdgeConnectionDetails.hooks';
import { getConnectedBy } from './RaisersEdgeConnectionDetails.utils';

interface IProps {
  integration: BlackbaudRaisersEdgeIntegration;
}

function RaisersEdgeConnectionDetails({ integration }: Readonly<IProps>): JSX.Element {
  const handleDisconnect = useDisconnect(integration);

  return (
    <IntegrationSummaryCard
      connectedBy={getConnectedBy(integration.get('authenticated_user'))}
      connectedOn={integration.get('date_created') ?? null}
      name={'raisers-edge-connection-details'}
      onDisconnect={handleDisconnect}
    />
  );
}

export default observer(RaisersEdgeConnectionDetails);
